import { useQuery } from "@apollo/client";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import Page from "components/base/Page";
import Spinner from "components/base/Spinner";
import { Link, useParams } from "react-router-dom";
import { FETCH_STOCK_SHIPMENTS } from "./graphql";

const StockShipmentsPage = () => {
  const { stockCategoryId } = useParams();
  const { loading, error, data } = useQuery(FETCH_STOCK_SHIPMENTS, {
    variables: { warehouseId: stockCategoryId },
    fetchPolicy: "network-only",
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const shipments = [...(data?.stockShipments || [])].sort(
    (a, b) => new Date(b.date) - new Date(a.date),
  );

  return (
    <Page
      title="Stock Records"
      subtitle={`Warehouse: ${data?.stockCategory?.name || ""}`}
      backTo="./.."
      className="h-screen"
      rightButtons={
        <Link to="new">
          <Button>+ New Record</Button>
        </Link>
      }
    >
      <div className="p-6 h-full flex flex-col">
        <div className="card p-0 flex-1 overflow-auto flex flex-col">
          {shipments.length === 0 ? (
            <div className="p-8 text-sm text-gray-500">
              No inventory records found.
            </div>
          ) : (
            <div className="whitespace-nowrap flex-1 overflow-auto relative">
              <table>
                <thead>
                  <tr className="sticky top-0 z-10 backdrop-blur bg-gray-50 bg-opacity-80 dark:bg-gray-700/50">
                    <th className="px-4 py-3">Date</th>
                    <th className="px-4">Move Type</th>
                    <th className="px-4">Ref</th>
                    <th className="px-4">Notes</th>
                  </tr>
                </thead>
                <tbody>
                  {shipments.map((shipment) => (
                    <tr
                      key={shipment.id}
                      className="border-y border-gray-100 dark:border-gray-700"
                    >
                      <td className="px-4 py-2">{shipment.date || "-"}</td>
                      <td className="px-4 py-2">{shipment.moveType || "-"}</td>
                      <td className="px-4 py-2">
                        <Link
                          to={`${shipment.id}`}
                          className="text-sky-600 hover:text-sky-700"
                        >
                          [{shipment.refType}] {shipment.refName || "-"} #
                          {shipment.id}
                        </Link>
                      </td>
                      <td className="px-4 py-2">{shipment.notes || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </Page>
  );
};

export default StockShipmentsPage;
